/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateProjectItemSampleCommandResult } from '../../models/update-project-item-sample-command-result';

export interface ApiProjectItemSamplesUpdateProjectItemSamplePatch$Plain$Params {
      body?: {
'Id'?: string;
'Description'?: string;
'Notes'?: string;
'ProjectItemId'?: string;
'ProjectItemSubmittalId'?: string;
'Attachments'?: Array<Blob>;
}
}

export function apiProjectItemSamplesUpdateProjectItemSamplePatch$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectItemSamplesUpdateProjectItemSamplePatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectItemSampleCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectItemSamplesUpdateProjectItemSamplePatch$Plain.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateProjectItemSampleCommandResult>;
    })
  );
}

apiProjectItemSamplesUpdateProjectItemSamplePatch$Plain.PATH = '/api/ProjectItemSamples/UpdateProjectItemSample';
